import * as generateLinks from "./lib/generateLinks";
import {
  computed,
  ComputedRef,
  inject,
  provide,
  WritableComputedRef
} from "vue";
import {
  Operator,
  AdTagExperimentVariant,
  Tracking,
  AnalyticsTracking
} from "@fresh8/types/src";

export function getTracking(
  adTagTracking: Tracking,
  adTagOperator: Operator | undefined,
  adTagExperimentVariant: AdTagExperimentVariant | undefined
): AnalyticsTracking {
  const searchParams = new URLSearchParams(window.location.search);

  const experimentImpressionUrl =
    adTagExperimentVariant?.operators?.[adTagOperator?._id as string]?.tracking
      ?.impressionUrl;

  const pixels = {
    clickThroughBehaviour: adTagTracking?.clickThroughBehaviour || "background",
    clickThroughUrl:
      generateLinks.getClickThroughUrl(
        adTagTracking?.clickThroughUrl,
        adTagTracking?.clickThroughBehaviour
      ) ||
      searchParams.get("clickTrackerUrl") ||
      "",
    impressionUrl:
      experimentImpressionUrl ||
      adTagTracking?.impressionUrl ||
      searchParams.get("impressionUrl") ||
      "",
    pixelType: adTagTracking?.pixelType || "image"
  };

  return {
    pixels
  };
}

export function createTracking(
  adTagTracking: ComputedRef<Tracking>,
  adTagOperator: WritableComputedRef<Operator | undefined>,
  adTagExperimentVariant: ComputedRef<AdTagExperimentVariant | undefined>
): ComputedRef<AnalyticsTracking> {
  const tracking = computed(() => {
    return getTracking(
      adTagTracking.value,
      adTagOperator.value,
      adTagExperimentVariant.value
    );
  });

  return tracking;
}

export type TrackingContext = ReturnType<typeof createTracking>;

export const TrackingSymbol = Symbol("TrackingCompSymbol");

export function provideTracking(
  trackingContext: TrackingContext
): TrackingContext {
  provide(TrackingSymbol, trackingContext);
  return trackingContext;
}

export function injectTracking(): TrackingContext {
  return inject<TrackingContext>(
    TrackingSymbol,
    computed(() => {
      return {
        pixels: {
          clickThroughBehaviour: "background",
          clickThroughUrl: "",
          impressionUrl: "",
          pixelType: "image"
        }
      };
    })
  );
}
